import { useCallback, useRef, useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
import { useVariable } from './useVariable';
import { equalArrays, isDefined, isFunction } from '../helpers';

var EQUAL_VALUES = function EQUAL_VALUES(v1, v2) {
  return v1 === v2;
};

export var useInput = function useInput(value, defaultValue, onChange, multiple, equalValues, needSortArrays, onBeforeOutsideChange, onBeforeInsideChange) {
  if (multiple === void 0) {
    multiple = false;
  }

  if (equalValues === void 0) {
    equalValues = EQUAL_VALUES;
  }

  if (needSortArrays === void 0) {
    needSortArrays = false;
  }

  var _useState = useState(value != null ? value : defaultValue),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var internalValueRef = useRef(value != null ? value : defaultValue);
  var handleChange = useVariable(onChange);
  var handleInsideChange = useVariable(onBeforeInsideChange);
  var handleOutsideChange = useVariable(onBeforeOutsideChange);
  var setValue = useCallback(function (value, fromOutside) {
    if (fromOutside === void 0) {
      fromOutside = false;
    }

    var newValue = isFunction(value) ? value(internalValueRef.current) : value; // handling before change callback

    if (fromOutside) {
      handleOutsideChange.current == null ? void 0 : handleOutsideChange.current(newValue);
    } else {
      handleInsideChange.current == null ? void 0 : handleInsideChange.current(newValue);
    } // updating value & ref


    internalValueRef.current = newValue;
    setInternalValue(newValue); // handling change callback

    if (!fromOutside) {
      handleChange.current == null ? void 0 : handleChange.current(newValue);
    }
  }, []); // handle update from outside

  useDidUpdateEffect(function () {
    if (multiple) {
      if (isDefined(value) && !equalArrays(value, internalValueRef.current, true, needSortArrays, equalValues)) {
        setValue(value, true);
      }
    } else {
      if (isDefined(value) && !equalValues(value, internalValueRef.current)) {
        setValue(value, true);
      }
    }
  }, [value]);
  return [internalValue, setValue, internalValueRef];
};